import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/shared/store";
import { ProductBasic } from "./model/ProductBasic";
import currencies from "src/shared/assets/currency";
export type CurrencyType = keyof typeof currencies;
export interface ProductsState {
  list: ProductBasic[];
  status: "pending" | "fulfilled" | "rejected";
  currencyType: CurrencyType;
}

const initialState: ProductsState = {
  list: [],
  currencyType: "TRY",
  status: "pending",
};

export const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setCurrencyType(state, action: PayloadAction<string>) {
      const nextCurrencyType = action.payload.toUpperCase() as CurrencyType;
      state.currencyType = nextCurrencyType;
    },
  },
});

export const { setCurrencyType } = productsSlice.actions;

export default productsSlice.reducer;
